import React from 'react';
import loadable from '@loadable/component';
import Modal from '../Modal';

const WelcomeSuccessContent = loadable(() => import('./WelcomeSuccesContent'));

const WelcomeSuccessModal = () => (
  <Modal name="welcomeSuccessModal">
    <WelcomeSuccessContent />
  </Modal>
);

export default WelcomeSuccessModal;
